//LOGIN
export const POST_LOGIN = "/admin/login"
export const POST_LOGOUT = "/logout"
export const POST_USER_RESET = "/admin/user/reset"
export const VALIDATE_2FA_URL = "/admin/validate-2fa-code"
export const RESEND_2FA_URL = "/admin/resend-2fa-code"

export const GET_FEATURES_AVAILABLE = "/admin/features-available"
export const GET_CLIENT_CONFIG = "/config"
export const GET_USER_PERMISSIONS = "/admin/perms"
export const SWITCH_USER_URL = "/admin/user/switch"

//USERS
export const ADMIN_USER_URL = "/admin/user"
export const ADMIN_USERS_CREATE_MULTIPLE_URL = "/admin/users/create-multiple"
export const USER_URL = "/user"
export const ADMIN_EMAIL_VALIDATION = "/admin/m/c"
export const USER_SEARCH_URL = "/admin/us"

export const ADMIN_META_TAGS = "/admin/meta-tags"
export const GET_ADMIN_ROLES = "/admin/role"

export const GET_USER_PROFILE_URL = "/user/profile"

//BUSINESS UNITS
export const GET_ADMIN_BUSINESS_UNITS = "/admin/business/vendor"
export const GET_BUSINESS_UNIT_URL = "/admin/business/"
export const CREATE_BUSINESS_UNIT_URL = "/admin/business"
export const UPDATE_BUSINESS_UNIT_URL = "/admin/business/"
export const DELETE_BUSINESS_UNIT_URL = "/admin/business/"

//PEOPLE
export const GET_CUSTOMER_URL = "/customers"
export const SEND_INVITE = "/admin/send-invite"
export const USER_META_TAGS = "/user-meta-tags"
export const REGISTER_URL = "/register"

//COMMUNICATIONS
export const COMMUNICATIONS_URL = "/communication"
export const WEB_ALERTS_URL = "/admin/web-alert"

//VENDORS
export const GET_VENDOR_URL = "/vendor"
export const GET_ADMIN_VENDORS_URL = "/admin/vendors"
export const GET_VENDORS_FOR_USER_URL = "/vendors-for-user"
//admin/vendors/{vendor id}/configs
export const UPDATE_CLIENT_CONFIGS = "/admin/vendors/"
export const ADMIN_CLIENT_SUCCESS_MANAGER_URL = "/admin/client-success-manager"
export const CLIENT_SUCCESS_MANAGER_URL = "/client-success-manager"

export const GET_FEATURES_URL = "/admin/feature/"

//POPUP
export const POPUP_SETUP_URL = "/admin/ad"

//EXPERIENCES
export const GET_EXPERIENCES_URL = "/admin/event"
export const GET_CATEGORIES_URL = "/admin/category"
export const POST_EXPERIENCES_ORDER = "/admin/events/order"
export const UPDATE_EVENT_PUBLISHED_FIELD =
  "/admin/events/bulk-publish-unpublish"
export const EVENT_BULK_DELETE = "/admin/events/bulk-delete"
export const GET_EVENT_INVITE_LIST_URL = "/admin/invite/vendor"
export const POST_INVITES_URL = "/admin/invites"
export const INVITE_URL = "/admin/invite"
export const SEND_APP_INVITES_URL = "/admin/users/send-app-invites"
export const EVENT_DROPDOWN_LIST_URL = "/admin/event-dropdown-list"
export const MENU_ITEM_URL = "/admin/menu-item"
export const GET_MENU_ICONS_URL = "/design/menu/icons"
export const DEEPLINK_CODES_URL = "/admin/event/deeplink-codes"
export const CLONE_EXPERIENCE_URL = "/admin/event/clone"

//DOMAINS
export const GET_DOMAINS_URL = "/admin/domain"
export const GET_DOMAIN_URL = "/admin/domain/"
export const DELETE_DOMAIN_URL = "admin/domain/"
export const CREATE_DOMAIN_URL = "admin/domain"
export const UPDATE_DOMAIN_URL = "admin/domain/"

// ONBOARDING_FLOW
export const GET_ONBOARDING_SETTINGS = "/admin/onboarding-screens"
export const POST_ONBOARDING_SETTINGS = "/admin/onboarding-screens"

// VISITORS
export const ADMIN_VISITOR_URL = "/admin/visitor"
export const EMAIL_SETUP_URL = "/admin/visitor/email-setup"

// PLACES
export const PLACES_URL = "/place"
export const ADMIN_PLACE_URL = "/admin/place"
export const CHAPTERS_URL = "/admin/places/chapters"
export const PLACES_REPORTS_URL = "/admin/places/reports"
export const PLACES_SUMMARY_REPORTS_URL = "/admin/places/summary-reports"

// BOOKINGS
export const CALENDAR_URL = "/calendar"
export const BOOKING_URL = "/booking"
export const BOOKING_TYPE_URL = "/admin/booking-type"
export const SUB_CALENDAR_REPORTS_URL =
  "/admin/booking/booking-type-grouped-reports"
export const CALENDAR_GROUP_REPORTS_URL =
  "/admin/booking/calendar-grouped-reports"
export const BOOKING_DATE_REPORTS_URL = "/admin/booking/time-grouped-reports"
export const BOOKING_STATUS_URL = "/admin/booking/status-grouped-reports"
export const USERS_BOOKING_URL = "/admin/booking/user-grouped-reports"
export const BOOKING_REPORTS_URL = "/admin/booking/booking-reports"

export const CALENDAR_EVENT_URL = "/calendar-event"

export const ADMIN_ORDER_URL = "/admin/order"
export const PRODUCT_URL = "/product"
export const STRIPE_PRODUCTS_URL = "/stripe-products"
export const STRIPE_PRICES_URL = "/stripe-prices"
export const ADMIN_PRODUCT_URL = "/admin/product"
export const FEATURE_RECIPIENTS_URL = "/admin/feature-recipients"

export const PERMISSION_URL = "/admin/permission"
export const ADMIN_ASSIGN_URL = "/admin/assign"

// CODES
export const CODES_URL = "/admin/code"

// ANALYTICS
export const DASHBOARD_SECTIONS_URL = "admin/user-ui-sections"
export const USER_REPORTS_URL = "/admin/reports/users"
export const ACTIVE_USERS_REPORTS_URL = "/admin/reports/active-users"
export const NEW_USERS_REPORTS_URL = "/admin/reports/new-users"
export const RECENT_EVENTS_URL = "/admin/recent-events"
export const BOOKING_PAYMENTS_URL = "/admin/booking-payments"
export const AD_REPORTS_URL = "/admin/ad/clicks"
export const FORM_BUILDER_PAYMENTS_URL = "/admin/form-builder-payments"

// FORMS
export const CATEGORY_FOR_FORM_URL = "/category-for-form"
export const TEASER_PRODUCTS_URL = "/teaser-products"
export const ORDER_CHECKOUT_URL = "/order-checkout"
export const ORDER_URL = "/order"
export const PRODUCT_USER_TAGS_URL = "/product-user-tags"

// PAYOUTS
export const STRIPE_CONNECTED_ACCOUNT_URL = "/stripe/connected-account"

//Axiscare
export const AXISCARE_REPORTS_URL = "/axiscare/failed-imports"

//=========================================================
//                  FROM TEMPLATE
//=========================================================
//AUTH

export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"

//TASKS
export const GET_TASKS = "/tasks"
